import { render, staticRenderFns } from "./ButtonNew.vue?vue&type=template&id=568d2241&scoped=true&"
import script from "./ButtonNew.vue?vue&type=script&lang=js&"
export * from "./ButtonNew.vue?vue&type=script&lang=js&"
import style0 from "./ButtonNew.vue?vue&type=style&index=0&id=568d2241&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d2241",
  null
  
)

export default component.exports